$('.hpe-subnav__list .hpe-subnav__item:not(.hpe-subnav__item--icon)').click(function () {
  const activeClass = 'hpe-subnav__item--active';

  $(this)
    .addClass(activeClass)
    .siblings('.hpe-subnav__item')
    .removeClass(activeClass);
});



// WEBPACK FOOTER //
// ./src/assets/toolkit/scripts/subnav.js